module.exports = __webpack_public_path__ + "static/media/CheckoutScreen.9deb93fd.png";